"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _selectCode = _interopRequireDefault(require("../../../../core/select-code"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  newEligibility: {
    classDivisionID: null,
    entryTypeID: null
  },
  isSubmitting: false
};
var _ref = /*#__PURE__*/_react.default.createElement("td", null);
class AddRaceEligibility extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onCancelNewEligibility", () => {
      this.setState(initialState);
    });
    _defineProperty(this, "_setValue", (field, value) => {
      this.setState({
        newEligibility: {
          ...this.state.newEligibility,
          [field]: value
        }
      });
    });
    _defineProperty(this, "_onAddEligibility", () => {
      this.setState({
        isSubmitting: true
      });
      this.props.addRaceEligibility({
        raceID: this.props.raceID,
        ...this.state.newEligibility
      }).then(result => {
        if (result && result.error) {
          this.setState({
            isSubmitting: false
          });
          this.props.onSetError(result.error);
        } else {
          this.setState(initialState);
        }
      });
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("tr", null, _ref, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "RefCodes",
      codeType: "class",
      value: this.state.newEligibility.classRef,
      onChange: this._setValue.bind(this, 'classRef'),
      clearable: false,
      required: true
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "ClassDivisions",
      includeCannotEnterOnline: true,
      classRef: this.state.newEligibility.classRef,
      value: this.state.newEligibility.classDivisionID,
      onChange: this._setValue.bind(this, 'classDivisionID'),
      clearable: false,
      required: true
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "EntryTypes",
      value: this.state.newEligibility.entryTypeID,
      onChange: this._setValue.bind(this, 'entryTypeID'),
      clearable: false,
      required: true
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onAddEligibility,
      size: "sm",
      disabled: this.state.isSubmitting || !this.state.newEligibility.classDivisionID || !this.state.newEligibility.entryTypeID
    }, "Add Eligibility"), ' ', /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCancelNewEligibility,
      size: "sm"
    }, "Clear"))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(AddRaceEligibility, undefined, (client, props) => ({
  addRaceEligibility(newEligibility) {
    return client.update('RaceEligibility.create', newEligibility);
  }
}));